import { createBrowserRouter, redirect } from 'react-router-dom';
import { supportedLngs } from '@/i18n/config';
import { getDetectedLanguage } from '@/i18n/detected';

import Error500 from '@/components/error/500';
import Home from '@/pages/Home';
import AppLayout from '../App';
import { legacyRoutes } from './legacy';

export const router = createBrowserRouter([
  {
    path: '/:lang',
    element: <AppLayout />,
    loader: async ({ request }) => {
      const path = new URL(request.url).pathname;
      const firstSegment = (path?.split('/')?.[1] || '') as Language;
      const isValidLang = supportedLngs.includes(firstSegment);

      if (!isValidLang) {
        const resolved = await getDetectedLanguage();
        const search = new URL(request.url)?.searchParams?.toString();
        const safeSearch = search ? `?${search}` : '';
        return redirect(`/${resolved}${path}${safeSearch}`);
      }
      return null;
    },
    children: [
      {
        path: '',
        element: <Home />,
        errorElement: <Error500 />,
      },
      ...legacyRoutes,
    ],
  },
  {
    path: '/',
    loader: async ({ request }) => {
      const resolved = await getDetectedLanguage();
      const search = new URL(request.url)?.searchParams?.toString();
      const safeSearch = search ? `?${search}` : '';
      return redirect(`/${resolved}${safeSearch}`);
    },
  },
]);
